module.exports = __webpack_public_path__ + "img/guangzhoushikelungongsi.45a9d6fb.png";